
export enum PartnerRole {
  User = 0,
  PartnerManager,
  PartnerAdmin,
  SuperAdmin = 100
}

export enum PartnerClassification {
  PersonalTrainer = 'Personal Trainer',
  Gym = 'Gym',
  WorkoutGroup = 'Workout Group'
}

export enum PartnerPageVersion {
  Preview,
  Version1,
  Version2,
  Version3Dark,
  Version3Light
}

export enum EventViewOption {
  Banner,
  Calendar
}

export enum MediaId {
  LOGO = 'logo_image',
  BANNER = 'banner_image',
  HEADER_1 = 'header1_image',
  HEADER_2 = 'header2_image',
  HEADER_3 = 'header3_image'
}

export enum MediaIdKey {
  logo_image,
  banner_image,
  header1_image,
  header2_image,
  header3_image
}

export enum MediaImageKey {
  Logo = 'logo',
  Details = 'details'
}

export enum MediaIdentifier {
  BannerImage,
  Logo,
  ImageDescription1,
  ImageDescription2,
  ImageDescription3,
}

export enum ButtonAlignment {
	Left,
	Center,
	Right
}

export enum ButtonSize {
	Small,
	Medium,
	Large,
	ExtraLarge
}

export enum SocialMediaType {
  Facebook,
  Instagram,
  Twitter,
  // LinkedIn,
  // Email,
  Email,
  LinkedIn
}

export enum FontAwesomeIconSize {
  ExtraSmall = 'fa-xs',
  Small = 'fa-sm',
  Large = 'fa-lg',
  XLarge = 'fa-2x',
  XXLarge = 'fa-3x',
  XXXLarge = 'fa-5x',
}

export enum TextSectionIdentifier {
  Description,
  FollowUs,
  WelcomeMessage,
  Header,
}
